import { processArticlesData } from 'helpers/global-search'
import { getGlobalSearchDisplay } from '../../selectors'
import resultBlockHoc from '../resultBlockHoc'
import Article from '../Article'
import SortableResultList from '../SortableResultList'

const mapStateToProps = state => ({
  displayGlobalSearch: getGlobalSearchDisplay(state)
})

export default resultBlockHoc({
  TileComponent: Article,
  blockName: 'Article',
  mapStateToProps,
  processData: processArticlesData,
  type: 'BOTArticlesSearchResults'
})(SortableResultList)
